module.exports = __webpack_public_path__ + "img/0Q3B7249_FoamcoreMatted_MockedUp.d778445c.jpg";